import HomePage from '../pages/home/HomePage'
import LoginPage from '../pages/login-form/LoginPage'
import KanbanBoard from '../components/board/KanbanBoard'
import Logout from '../pages/login-form/Logout'
import AccountCreationPage from '../pages/login-form/AccountCreationPage'
import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
      { name: 'home', path: '/', component: HomePage },
      { name: 'loginToken', path: '/login/:token*', component: LoginPage },
      { name: 'login', path: '/login', component: LoginPage },
      { name: 'logout', path: '/logout', component: Logout},
      { name: 'kanbanBoard', path: '/kanban-board/:office/:team', component: KanbanBoard},
      { name: 'accountCreation', path: '/create-account', component: AccountCreationPage},
    ], 
});

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})
export default router

export const whiteList = ['/login']


// WEBPACK FOOTER //
// ./src/router/index.js